import { useContext } from 'react';
import { WindowDimensionContext } from '../contexts/WindowDimensionContext';

// ----------------------------------------------------------------------

const useWindowDimension = () => useContext(WindowDimensionContext);

export default useWindowDimension;
